import { FC, memo } from "react";
import * as React from "react";

import { ArrowLeft as ArrowLeftIcon } from "@hl/base-components/lib/assets/icons.generated";
import { SECONDARY_COLOR } from "@hl/base-components/lib/theme/button";
import { WEIGHT_BOLD } from "@hl/base-components/lib/theme/typography";
import { AppSEO } from "@hl/shared-features/lib/features/layout/AppSEO";
import usePageVisitedEvent from "@hl/shared-features/lib/hooks/usePageVisitedEvent";
import { AppShell, Button, Container, Space, Text, Title } from "@mantine/core";
import { Link, useNavigate } from "react-router-dom";

import { TOOLS_URL } from "config";
import { AppFooter } from "~/features/layout/Footer";
import { AppHeader } from "~/features/layout/Header";

import { CreateOrEditGate } from "./CreateOrEditGate";

const CreateGate: FC = () => {
  const navigate = useNavigate();
  usePageVisitedEvent("CREATE_GATE");

  return (
    <>
      <AppSEO title="Create Gate" />
      <AppShell
        padding="md"
        header={
          <AppHeader
            leftButtons={
              <Link to={TOOLS_URL.gates.list}>
                <Button
                  color={SECONDARY_COLOR}
                  leftIcon={<ArrowLeftIcon height={12} />}
                >
                  Back
                </Button>
              </Link>
            }
          />
        }
        footer={<AppFooter />}
      >
        <Container size="sm" mb={116}>
          <Title order={3} weight={WEIGHT_BOLD}>
            Create a gate
          </Title>
          <Space h="xl" />
          <Text size="sm">
            Gates are rules you set that determine who can and can&apos;t access
            specific content. To pass a gate, someone must meet the conditions
            you specify below.
          </Text>
          <Space h={40} />
          <CreateOrEditGate onSave={() => navigate(TOOLS_URL.gates.list)} />
        </Container>
      </AppShell>
    </>
  );
};

export default memo(CreateGate);
